<div class="coming-soon-dialog v2-active">
    <header class="coming-soon-dialog__header">
        <div class="coming-soon-dialog__title-row">
            <img
                class="coming-soon-dialog__logo"
                [src]="logoPath"
                [alt]="logoAlt"
                width="32"
                height="32"
                loading="lazy"
            />
            <h2 class="coming-soon-dialog__title" [id]="titleId">
                {{ 'dialogs.comingSoon.title' | transloco: translationParams }}
            </h2>
        </div>
        <button
            mat-icon-button
            type="button"
            class="coming-soon-dialog__close"
            (click)="close()"
            [attr.aria-label]="'dialogs.comingSoon.closeAria' | transloco"
        >
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="coming-soon-dialog__body" role="document" [attr.aria-labelledby]="titleId">
        <p class="coming-soon-dialog__intro">
            {{ 'dialogs.comingSoon.intro' | transloco: translationParams }}
        </p>
        <p class="coming-soon-dialog__body-text">
            {{ 'dialogs.comingSoon.body' | transloco }}
        </p>
    </div>

    <footer class="coming-soon-dialog__footer">
        <button mat-flat-button type="button" class="coming-soon-dialog__action" (click)="close()">
            {{ 'dialogs.comingSoon.close' | transloco }}
        </button>
    </footer>
</div>
